import { useEffect } from "react";
import PageContainer from "@components/layout/PageContainer";
import SellReportForm from "@components/dynamic/SellReportForm";

const SellByMonthReport = () => {
  useEffect(() => {
  }, []);


  return (
    <PageContainer
      title="Reporte de Ventas por mes"
      backUrl="/user/dashboard-accounting"
    >
      <SellReportForm />
    </PageContainer >
  );
}

export default SellByMonthReport;
